import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import './global.css';

import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import ReorderableListExperiment from './pages/experiments/ReorderableListExperiment';
import ScrapHeapSprintExperiment from './pages/experiments/ScrapHeapSprintExperiment';
import PhotoGalleryExperiment from './pages/experiments/PhotoGalleryExperiment';
import Navbar from './components/Navbar';

/**
 * Routes that manage their own width. `.container` caps at 1280px, which is right for prose and
 * wrong for a gallery — it left a third of a wide screen empty.
 */
const WIDE_ROUTES = new Set(['/experiments/photo-gallery']);

const Main: React.FC = () => {
  const { pathname } = useLocation();
  const wide = WIDE_ROUTES.has(pathname);

  return (
    <main className={wide ? 'w-full py-8' : 'container py-8 space-y-10'}>
      <Routes>
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/" element={<HomePage />} />
        {/* Canonical Reorderable List experiment */}
        <Route path="/experiments/reorderable-list" element={<ReorderableListExperiment />} />
        {/* Unity game experiment */}
        <Route path="/experiments/scrapheap-sprint" element={<ScrapHeapSprintExperiment />} />
        {/* Scroll-driven photo gallery */}
        <Route path="/experiments/photo-gallery" element={<PhotoGalleryExperiment />} />
        {/* Backwards compatibility legacy paths */}
        <Route
          path="/experiments/example"
          element={<Navigate to="/experiments/reorderable-list" replace />}
        />
        <Route path="/example" element={<Navigate to="/experiments/reorderable-list" replace />} />
      </Routes>
    </main>
  );
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Navbar />
      <Main />
    </BrowserRouter>
  );
};

const container = document.getElementById('root');
if (!container) throw new Error('Root container not found');
createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
